import React from 'react';
import {PricingStructure } from '@medtrail/shared-ui';
import Header from '../../components/header';
import { ROUTE_FLAG, WEBSITE } from '../../constants';


const pricingStructure = () => {

  return (
    <React.Fragment>
      <div className='headerContainer'>
        <Header active={null} routeFlag={ROUTE_FLAG.paymentPolicyPage}/>
      </div>
      <PricingStructure website={WEBSITE}/>
    </React.Fragment>
  );

};

export default pricingStructure;
